/* eslint-disable import/no-unresolved */
import React from "react";
import "@swan-admin/swan-web-component/index.css";
import { Outlet } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ContextProvider from "./context/contextProvider";
import interceptor from "./service/interceptor";
import ConfigWrapper from "./wrapper/ConfigWrapper";


interceptor();
function App() {
  return (
      <ContextProvider>
        <ConfigWrapper>
        <div className="App app-main h-full w-full">
          <HelmetProvider>
            <Outlet />
            </HelmetProvider>
        </div>
        </ConfigWrapper>
      </ContextProvider>

  );
}

export default App;
